import { Bonus as BonusData } from '../../../../../../types/bonus';

export class Bonus {
	private _data: BonusData;

	constructor(data: BonusData) {
		this._data = data;
	}

	get reactions() {
		return this._data.reactions ?? [];
	}

	get id() {
		return this._data.id;
	}
}
